module.exports = __webpack_public_path__ + "img/t2-events.e8e38eea.png";